import request from '@/utils/request'

// 查询拼团设置列表
export function queryGroupBuySetting(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy.queryGroupBuySetting',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加拼团设置
export function saveGroupBuySetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy.saveGroupBuySetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改拼团设置
export function updateGroupBuySetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy.updateGroupBuySetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除拼团设置
export function deleteGroupBuySetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy.deleteGroupBuySetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}